import { beckyTheme as beckyConfig } from '@coolblue-development/themes';
import { createTheme, Theme } from '@mui/material/styles';

// becky defines `theme.spacing` as the array [0, 4, 8, 12, 16, 20, 24] (a linear
// 4px scale). MUI logs "The `theme.spacing` array type cannot be combined with
// non integer values" whenever a non-integer multiplier is requested, which many
// MUI internals (Autocomplete, DataGrid, Snackbar, ...) do. Because the scale is
// exactly `4 * factor`, re-creating the theme with `spacing: 4` reproduces every
// existing value while silencing the warning.
// See https://github.com/mui/material-ui/issues/29677
export const appTheme: Theme = createTheme({
  ...beckyConfig,
  spacing: 4
});
